// extracted by mini-css-extract-plugin
export default {"dinein":"orderType_dinein__a7zfT","pickup":"orderType_pickup__N-O1e","delivery":"orderType_delivery__8InpM","kiosk":"orderType_kiosk__SZ7HR"};